import { useState, useEffect } from 'react';

const faqs = [
  {
    q: 'Welche Leistungen bietet gowiTEC an?',
    a: 'gowiTEC bietet Sondermaschinenbau, SPS-Programmierung und Steuerungstechnik, Roboter- und Handlingsysteme, industrielle Bildverarbeitung, mechanische Fertigung sowie Hard- und Softwareentwicklung. Alle Lösungen werden individuell auf Ihre Anforderungen zugeschnitten.',
  },
  {
    q: 'Wie lange ist gowiTEC bereits tätig?',
    a: 'gowiTEC wurde 1992 gegründet und blickt auf über 30 Jahre Erfahrung im Sondermaschinenbau und in der Automatisierungstechnik zurück. In dieser Zeit wurden mehr als 500 Projekte erfolgreich realisiert.',
  },
  {
    q: 'Für welche Branchen arbeitet gowiTEC?',
    a: 'gowiTEC realisiert Automatisierungsprojekte für den allgemeinen Maschinenbau, die Fertigungsindustrie, den Anlagenbau sowie für mittelständische Unternehmen in ganz Deutschland und Europa. Jede Lösung wird individuell auf den jeweiligen Produktionsprozess abgestimmt.',
  },
  {
    q: 'Welche SPS-Systeme werden bei gowiTEC eingesetzt?',
    a: 'gowiTEC arbeitet mit allen führenden SPS-Plattformen: Siemens SIMATIC S7 / TIA Portal, Beckhoff TwinCAT sowie OMRON Sysmac / NJ / NX. Zusätzlich werden SCADA- und HMI-Visualisierungen sowie Fernwartungslösungen realisiert.',
  },
  {
    q: 'Realisiert gowiTEC auch Roboter- und Handlingsysteme?',
    a: 'Ja, gowiTEC plant und realisiert vollautomatische Roboter- und Handlingsysteme für die Industrie. Wir integrieren Industrieroboter in bestehende Produktionslinien – von der Auswahl des passenden Roboters bis zur vollständigen Inbetriebnahme.',
  },
  {
    q: 'Wie kann ich ein Projekt bei gowiTEC anfragen?',
    a: 'Sie können Ihr Projekt ganz einfach über das Online-Formular auf unserer Anfrage-Seite einreichen, uns per E-Mail an anfrage@gowitec.de kontaktieren oder direkt unter +49 1776512122 anrufen. Wir melden uns innerhalb von 24 Stunden mit einer ersten Einschätzung – kostenlos und unverbindlich.',
  },
];

const SCHEMA_JSON = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: a,
    },
  })),
});

const FaqSection = () => {
  const [open, setOpen] = useState<number | null>(null);

  useEffect(() => {
    const id = 'schema-faq';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = SCHEMA_JSON;
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, []);

  return (
    <section className="py-24 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">

          {/* Left */}
          <div className="lg:col-span-2">
            <span className="text-[#DC2626] text-xs font-semibold tracking-widest uppercase">FAQ</span>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-3 mb-4 leading-tight">
              Häufig gestellte Fragen
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Antworten auf die wichtigsten Fragen rund um unsere Leistungen, Erfahrung und Zusammenarbeit.
            </p>
            <a
              href="/kontakt"
              className="inline-flex items-center gap-2 border border-gray-200 hover:border-[#1E3A8A] text-gray-700 hover:text-[#1E3A8A] font-semibold px-6 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-question-answer-line"></i>
              </span>
              Weitere Fragen? Kontakt
            </a>
          </div>

          {/* Right – Accordion */}
          <div className="lg:col-span-3 flex flex-col divide-y divide-gray-100" role="list">
            {faqs.map((faq, i) => (
              <div key={i} className="py-5" role="listitem">
                <button
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-start justify-between gap-4 text-left cursor-pointer group"
                  aria-expanded={open === i}
                  aria-controls={`faq-answer-${i}`}
                  id={`faq-btn-${i}`}
                >
                  <h4 className="text-gray-900 font-semibold text-base leading-snug group-hover:text-[#1E3A8A] transition-colors">
                    {faq.q}
                  </h4>
                  <span
                    className={`w-6 h-6 flex items-center justify-center shrink-0 mt-0.5 rounded-full border transition-all duration-200 ${
                      open === i
                        ? 'bg-[#1E3A8A] border-[#1E3A8A] text-white'
                        : 'border-gray-200 text-gray-400 group-hover:border-[#1E3A8A] group-hover:text-[#1E3A8A]'
                    }`}
                    aria-hidden="true"
                  >
                    <i className={`ri-${open === i ? 'subtract' : 'add'}-line text-sm`}></i>
                  </span>
                </button>
                <div
                  id={`faq-answer-${i}`}
                  role="region"
                  aria-labelledby={`faq-btn-${i}`}
                  className={`overflow-hidden transition-all duration-300 ${open === i ? 'max-h-96 mt-3' : 'max-h-0'}`}
                >
                  <p className="text-gray-500 text-sm leading-relaxed pr-10">
                    {faq.a}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default FaqSection;
